import { CalendarRange } from "lucide-react";
import { fmtDate } from "../proposal/format";

// Under the planned-start question: the schedule quoted in the proposal
// and, once the client has given a date, the indicative calendar that
// follows from it (same maths as the Statement of Work, section 2).
export function TimelinePreview({ timeline, deadline }) {
  if (!timeline) return null;
  const cal = timeline.calendar;
  const phases = cal?.phases || timeline.phases || [];
  const endsAfterDeadline = !!(cal?.ends_on && deadline && cal.ends_on > deadline);
  const quoted = timeline.total_days
    ? `${timeline.total_days} working days${timeline.trigger ? ` from ${timeline.trigger}` : ""}`
    : timeline.fallback
      ? `${timeline.fallback.value} ${timeline.fallback.unit} live period`
      : null;
  if (!quoted) return null;
  return (
    <div className="rounded-lg border border-stone-200 bg-white p-4 sm:p-5 flex flex-col gap-3 text-[15px] leading-relaxed text-stone-700" data-testid="cm-timeline-preview">
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0 bg-[#1B4F8A]/10 text-[#1B4F8A]">
          <CalendarRange className="w-4 h-4" />
        </span>
        <div className="flex flex-col gap-1.5 min-w-0">
          <p>
            The proposal quotes <span className="font-semibold" data-testid="cm-timeline-quoted">{quoted}</span>.
          </p>
          {phases.map((ph, i) => (
            <p key={i} className="text-sm text-stone-600" data-testid={`cm-timeline-phase-${i}`}>
              {phases.length > 1 && ph.phase_name ? <span className="font-medium text-stone-800">{ph.phase_name}: </span> : null}
              {(ph.stages || []).map((s) => `${s.label} ${s.days}${cal ? ` (to ${fmtDate(s.end)})` : ""}`).join(" · ")}
              {ph.unit ? `${ph.value} ${ph.unit}${cal ? ` (${fmtDate(ph.start)} to ${fmtDate(ph.end)})` : ""}` : null}
            </p>
          ))}
          {cal ? (
            <p data-testid="cm-timeline-ends">
              Starting on <span className="font-semibold">{fmtDate(cal.start)}</span>, the work would complete by <span className="font-semibold">{fmtDate(cal.ends_on)}</span>. These dates are indicative and will appear in the Statement of Work.
            </p>
          ) : (
            <p className="text-sm text-stone-500" data-testid="cm-timeline-undated">
              Enter the date above to see the indicative calendar; without it the Statement of Work records the schedule in working days only.
            </p>
          )}
          {endsAfterDeadline && (
            <p className="text-sm font-medium text-amber-800" data-testid="cm-timeline-after-deadline">
              That finishes after your deadline of {fmtDate(deadline)}: see the note on the deadline above.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
